

export class CacheService {

    static set(name, data, ttlMs) {

        const payload = {
            data,
            expiry: Date.now() + ttlMs,
        };
        localStorage.setItem(name, JSON.stringify(payload));
    } 

    static get(name) {

        const cached = localStorage.getItem(name);
        if (!cached) { return null;}

        try {
            const { data, expiry } = JSON.parse(cached);

            if (Date.now() > expiry) {

                localStorage.removeItem(name);
                return null;

            } else {

                return data;

            }
        } catch (err) {

            localStorage.removeItem(name);
            return null;
        }
    }
}